export default __webpack_public_path__ + "static/media/drum_four.6753f8ab.mp3";